export default __webpack_public_path__ + "locales/si/SharingPanel.json?hash=63557dd74aea78fe2770558b688f7cfe";